module.exports = __webpack_public_path__ + "img/3.c9eb7b95.jpg";